<template>
  <ModalFilterTransaction v-if="modalShowFilterTransaction" @closeModal="closeModal" @submitFilter="submitFilter" />
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Riwayat Transaksi" />
      <div
        class="border-t-2 border-primary bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100">
        <div v-if="false" class="bg-yellow-200 border-l-4 border-warning text-primary p-4 mb-4" role="alert">
          <p class="font-bold">Connection Status</p>
          <p>Attempting to connect to real-time updates...</p>
        </div>
        <div id="table-header" class="mb-5 flex justify-between items-end">
          <div class="mb-5 flex justify-between">
            <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />
          </div>
        </div>
        <div v-if="isLoading" class="flex justify-center items-center py-4">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Kode</TableHeadCell>
                    <TableHeadCell>Nama Pelanggan</TableHeadCell>
                    <TableHeadCell>Staff</TableHeadCell>
                    <TableHeadCell>Metode pembayaran</TableHeadCell>
                    <TableHeadCell numeric>Grand Total</TableHeadCell>
                    <TableHeadCell>Keterangan</TableHeadCell>
                    <TableHeadCell>Waktu Transaksi</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Cash Register</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allSalesOrders.length == 0">
                    <TableCell colspan="18" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(transaction, index) in allSalesOrders" :key="transaction.id"
                    :index="index" alternateRow isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ transaction.code }}</TableCell>
                    <TableCell>{{ transaction.customer_name }}</TableCell>
                    <TableCell>{{this.allMarketings?.find(m => m.id == transaction.marketing_id)?.name}}</TableCell>
                    <TableCell>{{this.allPaymentMethods?.find(pm => pm.id == transaction.payment_method_id)?.name}}
                    </TableCell>
                    <TableCell :rupiah="transaction.grand_total" />
                    <TableCell>{{ transaction.note }}</TableCell>
                    <TableCell>{{ formatTime(transaction.createdAt) }}</TableCell>
                    <TableCell>{{ transaction.status }}</TableCell>
                    <TableCell>{{ transaction.cash_register ? `${this.formatDate(transaction.cash_register.time_start)}
                      - ${this.formatDate(transaction.cash_register.time_end)}` : "-" }}</TableCell>
                    <TableCell>
                      <RouterLink :to="{ path: '/order', query: { orderId: transaction.id } }"
                        class="bg-warning hover:bg-hover-warning flex justify-center items-center mx-1 p-2 rounded-md group">
                        <ShoppingCartIcon class="h-4 w-4 text-light-900 group-hover:text-primary" />
                      </RouterLink>
                      <RouterLink :to="{ path: '/payment', query: { orderId: transaction.id } }"
                        class="bg-info hover:bg-hover-info flex justify-center items-center mx-1 p-2 rounded-md group">
                        <EyeIcon class="h-4 w-4 text-white group-hover:text-white" />
                      </RouterLink>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
  import PageTitle from "@/components/PageTitle.vue";
  import IndexView from "@/views/IndexView.vue";
  import { EyeIcon, ShoppingCartIcon } from "@heroicons/vue/24/solid";
  import AddButton from "@/components/buttons/AddButton.vue";
  import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
  import { io } from "socket.io-client";
  import { mapGetters } from "vuex";
  import PaginationButtons from "@/components/PaginationButtons.vue";
  import { TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell } from '@/components/table';
  import ViewContainer from "@/components/ViewContainer.vue";
  import { formatTime } from "@/helpers/formatTime";

  export default {
    name: "TransactionView",
    components: {
      PageTitle, IndexView, ShoppingCartIcon, AddButton, ModalFilterTransaction, EyeIcon, PaginationButtons,
      TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, ViewContainer
    },
    data() {
      return {
        modalShowFilterTransaction: false,
        isBlur: false,
        listTransaction: [],
        socket: null,
        message: "",
        messages: [],
        isConnected: false,
        isLoading: false,
        currentPage: 1,
        totalPages: 1,
        filter: {}
      };
    },
    async created() {
      this.connectWebSocket();
      this.fetchSalesOrders();
      this.fetchAdditionalData();
    },
    computed: {
      ...mapGetters('sales_orders', ['allSalesOrders']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('marketings', ['allMarketings']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
    },
    beforeUnmount() {
      try {
        if (this.socket) {
          // Remove all listeners to prevent memory leaks
          this.socket.removeAllListeners();
          this.socket.disconnect();
          this.socket = null;
        }
        this.isConnected = false;
        this.listTransaction = [];
        this.messages = [];
      } catch (error) {
        console.error("Error during cleanup:", error);
      }
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchSalesOrders({ page: newVal });
        },
      },
    },
    methods: {
      formatTime,
      formatDate(date) {
        if (!date) return "-";
        const d = new Date(date);
        const pad = (num) => num.toString().padStart(2, "0");

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear().toString().slice(-2);
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
      formateISODate(date) {
        const localDate = new Date(date);
        const offset = localDate.getTimezoneOffset();
        const adjustedDate = new Date(localDate.getTime() - (offset * 60 * 1000));
        return adjustedDate.toISOString().split('T')[0];
      },
      async fetchSalesOrders(params = {}) {
        if (!params.page) params.page = this.currentPage;
        if (!params.limit) params.limit = 50;
        try {
          const { pagination } = await this.$store.dispatch('sales_orders/fetchSalesOrders', params);
          if (pagination) {
            this.totalPages = pagination.totalPages;
          }
        } catch (error) {
          console.log(error);
        }
      },
      async fetchAdditionalData() {
        this.$store.dispatch('tables/fetchTables', { limit: 1000 });
        this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
        this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
      },
      connectWebSocket() {
        try {
          this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
            reconnection: true, // Enable auto-reconnection
            reconnectionAttempts: 5, // Maximum number of reconnection attempts
            timeout: 10000, // Connection timeout in milliseconds
          });

          this.socket.on("connect_error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.socket.on("disconnect", (reason) => {
            this.messages.push(reason);
            this.isConnected = false;
          });

          // Menerima pesan dari server
          this.socket.on("serverMessage", (data) => {
            this.handleWebSocketMessage(data);
            this.messages.push(data.message);
          });

          this.socket.on("welcome", (data) => {
            this.messages.push(data.message);
          });

          this.socket.on("new_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("update_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("delete_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("connect", () => {
            this.isConnected = true;
          });

          this.socket.on("error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.handleReconnect();
        } catch (error) {
          this.isConnected = false;
        }
      },
      sendMessage() {
        // Kirim pesan ke server
        this.socket.emit("clientMessage", this.message);
        this.message = ""; // Reset input
      },
      handleWebSocketMessage(data) {
        this.isLoading = true;
        try {
          let index;

          // Validasi data terlebih dahulu
          if (!data || !data.type) {
            return;
          }

          switch (data.type) {
            case "INITIAL_DATA":
              if (Array.isArray(data.transactions)) {
                this.listTransaction = data.transactions;
                this.fetchSalesOrders();
              } else {
                console.warn("Invalid transactions data format:", data);
              }
              break;
            case "NEW_ITEMS":
              if (data.items && data.route == "sales-order") {
                this.listTransaction.unshift(data.items);
                this.fetchSalesOrders();
              }
              break;
            case "UPDATE_ITEMS":
              if (data.items && data.items.id && data.route == "sales-order") {
                index = this.listTransaction.findIndex(
                  (t) => t.id === data.items.id
                );
                if (index !== -1) {
                  this.listTransaction.splice(index, 1, data.items);
                }
                this.fetchSalesOrders();
              }
              break;
            case "DELETE_ITEMS":
              if (data.id && data.route == "sales-order") {
                this.listTransaction = this.listTransaction.filter(
                  (transaction) => String(transaction.id) !== String(data.id)
                );
                this.fetchSalesOrders();
              }
              break;
            default:
              console.warn("Unknown message type:", data.type);
          }
        } catch (error) {
          console.error("Error handling websocket message:", error);
        } finally {
          this.isLoading = false;
        }
      },
      handleReconnect() {
        if (this.socket) {
          this.socket.on("reconnect_attempt", (attemptNumber) => {
            console.log(`Reconnection attempt ${attemptNumber}`);
          });

          this.socket.on("reconnect", () => {
            console.log("Reconnected successfully");
            this.isConnected = true;
            // Mungkin perlu memuat ulang data
            this.socket.emit("requestInitialData");
          });

          this.socket.on("reconnect_failed", () => {
            console.log("Failed to reconnect");
            this.isConnected = false;
          });
        }
      },
      showModal() {
        this.modalShowFilterTransaction = true;
        this.isBlur = true;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowFilterTransaction = false;
          this.isBlur = false;
        }, 200);
      },
      submitFilter(filter) {
        this.filter = filter;
        let params = {};

        if (this.filter.capacity) {
          params.capacity = this.filter.capacity;
        }

        if (this.filter.type) {
          params.order_type = this.filter.type;
        }

        if (this.filter.status) {
          params.status = this.filter.status;
        }

        if (this.filter.marketing_id) {
          params.marketing_id = this.filter.marketing_id;
        }

        if (this.filter.payment_method_id) {
          params.payment_method_id = this.filter.payment_method_id;
        }

        if (this.filter.table_id) {
          params.table_id = this.filter.table_id;
        }

        if (this.filter.cash_register_id) {
          params.cash_register_id = this.filter.cash_register_id;
        }

        if (this.filter.customer_name) {
          params.customer_name = this.filter.customer_name;
        }

        if (this.filter.rangeDate) {
          const start_date = this.formateISODate(this.filter.rangeDate[0]);
          const end_date = this.formateISODate(this.filter.rangeDate[1]);
          params.start_date = start_date;
          params.end_date = end_date;
          params.date_column = 'createdAt';
        }

        this.fetchSalesOrders(params);
        this.updateFilter(filter);
      },
      updateFilter(filter) {
        this.filter = filter;
      },
    },
  };
</script>
